import { styled, Image } from '@staffino/primitive-controls';
import { View } from '@staffino/primitives';
import React from 'react';
import omitProps from './omit-props';

type Props = {
  shadow?: boolean;
  bgColor?: string;
  defaultSource?: string;
  smallAvatar?: string | false;
  source?: string;
  children?: React.ReactFragment;
  size?: string | string[];
  circle?: boolean;
};

const bl = ['size', 'circle', 'bgColor', 'shadow', 'border', 'smallAvatar'];

type StyledAvatarProps = {
  circle?: boolean;
  hide?: boolean;
  smallAvatar?: boolean;
};
const StyledAvatar = styled(Image)<StyledAvatarProps>((props) => ({
  borderRadius: props.circle ? '50%' : '4px',
  height: '40px',
  width: '40px',
  smallAvatar: 'xMini',
  shadow: 4,
  marginBottom: '',
  border: props.hide ? 0 : '1px solid rgba(216, 225, 235, 0.7)',
  ...(props.smallAvatar && {
    position: 'absolute',
    bottom: 0,
    right: 0,
  }),
}));

const WrapperView = styled(View)(() => ({
  flexShrink: 0,
}));

const Wrapper = styled(omitProps([...bl, 'defaultSource'], View))((props) => ({
  position: 'relative',
  marginBottom: props.shadow ? '11%' : 0,
}));

const Avatar = ({
  shadow,
  defaultSource = 'https://cdn-static.staffino.com/images/default/default.png',
  smallAvatar,
  children = null,
  ...props
}: Props) => {
  const { bgColor = null, source = 'circle' } = props;
  return (
    <WrapperView>
      <Wrapper shadow={shadow}>
        <StyledAvatar
          defaultSource={bgColor ? '' : defaultSource}
          source={source}
          {...props}
        />
        {smallAvatar && smallAvatar !== source && (
          <StyledAvatar {...props} source={smallAvatar} />
        )}
        {children}
      </Wrapper>
    </WrapperView>
  );
};

export default Avatar;
